import { Card, CardBody, Col } from "reactstrap";
import LargeDropdown from "./LargeDropdown";
import SmallDropdown from "./SmallDropdown";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DropdownSizingTitle } from "../../../../Constants/Constants";
import { DropdownSizingSubTitle } from "../../../../Data/UiKits/Dropdown";

const DropdownSizing = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={DropdownSizingTitle} span={DropdownSizingSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <LargeDropdown />
            <SmallDropdown />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DropdownSizing;
